import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO, { orgJsonLd, breadcrumbJsonLd } from "../components/SEO";
import Reveal from "../components/Reveal";
import Icon from "../components/Icon";
import LeadForm from "../components/LeadForm";
import { INDUSTRIES } from "../data/siteData";

export default function IndustriesPage() {
  return (
    <>
      <SEO
        title="Industries We Serve — Startups, SMEs, D2C, SaaS, Fintech & Manufacturing | Complisure"
        description="Sector-specialist CA, CS and legal advisory for startups, SMEs, D2C brands, SaaS companies, NBFC/fintech and manufacturing businesses across India."
        canonical="https://compliance-capital-1.preview.emergentagent.com/industries"
        jsonLd={[orgJsonLd, breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Industries", path: "/industries" }])]}
      />
      <section className="relative overflow-hidden pb-20 pt-36">
        <div className="blob blob-float right-[-6%] top-[-8%] h-96 w-96 bg-brand-blue/10" />
        <div className="dot-grid absolute inset-0 opacity-[0.1]" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-[-0.02em] text-brand-navy sm:text-5xl">
              We speak the dialect of <span className="text-gradient">your industry's P&L</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-gray sm:text-lg">
              A SaaS metric, a textile cost sheet and an NBFC's RBI return are three different languages. Our practice teams are fluent in all six below.
            </p>
          </Reveal>

          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.name} delay={(i % 3) * 0.08}>
                <div data-testid={`industries-card-${ind.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="glass card-lift h-full rounded-3xl p-8">
                  <span className="mb-5 flex h-13 w-13 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-blue to-brand-sky p-3 text-white shadow-lg shadow-brand-blue/25">
                    <Icon name={ind.icon} className="h-6 w-6" />
                  </span>
                  <h2 className="font-display text-xl font-bold tracking-tight text-brand-navy">{ind.name}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-brand-gray">{ind.desc}</p>
                  <Link to="/contact" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue transition-all hover:gap-3">
                    Discuss your business <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-20 grid items-center gap-10 lg:grid-cols-2">
            <Reveal>
              <h2 className="font-display text-3xl font-bold tracking-tight text-brand-navy">Your industry, our playbook.</h2>
              <p className="mt-4 text-base leading-relaxed text-brand-gray">
                Even if your sector isn't listed — healthcare, logistics, hospitality, education — the fundamentals of clean compliance and investor-ready finance transfer. Tell us your model; we'll tell you honestly if we're the right fit.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <LeadForm sourcePage="/industries" />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
